<div class="activity-editor-page">
  <header class="editor-header">
    <button mat-icon-button type="button" (click)="cancel()" matTooltip="Volver al listado">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="header-copy">
      <h1>{{ pageTitle }}</h1>
      <p>{{ isEditMode ? 'Actualiza la colaboración y sus roles opcionales' : 'Crea una colaboración disponible para personas' }}</p>
    </div>
  </header>

  <section *ngIf="isLoading" class="editor-panel">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Cargando colaboración...</p>
    </div>
  </section>

  <form *ngIf="!isLoading" [formGroup]="form" class="form-container">
    <section class="editor-panel">
      <h3>
        <mat-icon>groups</mat-icon>
        Información general
      </h3>

      <div class="form-grid">
        <mat-form-field>
          <mat-label>Nombre</mat-label>
          <input matInput formControlName="name" placeholder="ej: Atención pastoral">
          <mat-error *ngIf="getControl('name')?.hasError('required')">El nombre es requerido</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Área</mat-label>
          <mat-select formControlName="areaId">
            <mat-option *ngFor="let option of areaOptions" [value]="option.id">{{ option.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Niveles organizativos</mat-label>
          <mat-select formControlName="allowedOrganizationLevelIds" multiple>
            <mat-option *ngFor="let level of organizationLevels" [value]="level.id">{{ level.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Descripción</mat-label>
          <input matInput formControlName="description" placeholder="Descripción opcional">
        </mat-form-field>

        <mat-checkbox formControlName="isActive">Activa</mat-checkbox>
      </div>
    </section>

    <section class="editor-panel roles-panel" formArrayName="roles">
      <div class="section-title">
        <h3>
          <mat-icon>badge</mat-icon>
          Roles
        </h3>
        <button mat-stroked-button type="button" (click)="addRole()">
          <mat-icon>add</mat-icon>
          Agregar rol
        </button>
      </div>

      <p *ngIf="roles.length === 0" class="roles-empty">Esta colaboración se asignará sin rol específico.</p>

      <div class="role-row" *ngFor="let role of roles.controls; let i = index" [formGroupName]="i">
        <input type="hidden" formControlName="id">

        <mat-form-field>
          <mat-label>Nombre del rol</mat-label>
          <input matInput formControlName="name" placeholder="ej: Responsable">
          <mat-error *ngIf="role.get('name')?.hasError('required')">El nombre es requerido</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Nombre corto</mat-label>
          <input matInput formControlName="shortName" placeholder="ej: Resp.">
        </mat-form-field>

        <mat-form-field>
          <mat-label>Descripción</mat-label>
          <input matInput formControlName="description" placeholder="Descripción opcional">
        </mat-form-field>

        <mat-checkbox [checked]="role.get('isActive')?.value" (change)="setRoleActive(i, $event.checked)">Activo</mat-checkbox>
        <mat-checkbox [checked]="role.get('isDefault')?.value" [disabled]="!role.get('isActive')?.value" (change)="setRoleDefault(i, $event.checked)">Rol predeterminado</mat-checkbox>

        <button mat-icon-button type="button" matTooltip="Quitar rol" (click)="removeRole(i)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </section>
  </form>

  <footer class="editor-footer">
    <span class="spacer"></span>
    <button mat-stroked-button type="button" (click)="cancel()" [disabled]="isSaving">
      <mat-icon>cancel</mat-icon>
      Cancelar
    </button>
    <button mat-flat-button color="primary" type="button" (click)="saveActivity()" [disabled]="!form.valid || isSaving">
      <mat-spinner *ngIf="isSaving" diameter="20" class="button-spinner"></mat-spinner>
      <mat-icon *ngIf="!isSaving">save</mat-icon>
      {{ isSaving ? 'Guardando...' : 'Guardar' }}
    </button>
  </footer>
</div>
